import { render, staticRenderFns } from "./BDropdownItem.vue?vue&type=template&id=2870884e&"
import script from "./BDropdownItem.vue?vue&type=script&lang=js&"
export * from "./BDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports